/**
 * The data object associated with an action should reflect the input parameters for the corresponding function here:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/raygun4js/index.d.ts#L177
 */
type SendData = {
  // Optional: info/warn logs carry no error, and the transmit path passes `undefined` for them.
  error?: Error;
  tags?: string[];
  message?: string;
  customData?: Record<string, unknown>;
};

type TrackEventData = {
  type: string;
  path: string;
};

/**
 * The Raygun4JS client library to send tracking events to Raygun4JS for monitoring frontend performance and tracking errors / logs.
 *
 * This should not be used
 * @param key - The action to perform, e.g., 'trackEvent'.
 * @param value - The object of event, e.g., `{ metadata: { state: isLoading: true }}`.
 *
 * This should not be used directly. Instead, please use the logger. It will use this function to log client-side errors.
 */
function rg4js(key: 'send', value: SendData): void;
function rg4js(key: 'trackEvent', value: TrackEventData): void;
function rg4js(
  key: 'send' | 'trackEvent',
  value: SendData | TrackEventData,
): void {
  if ((window as unknown as { rg4js: () => void }).rg4js) {
    (window as unknown as { rg4js: (...args: unknown[]) => void }).rg4js(
      key,
      value,
    );
  } else {
    console.error('rg4js is not available in the window object.');
  }
}

export { rg4js };
